module.exports = "//public.getcloudapp.com/packs/media/images/upload-cloud-2ffcd2124a4dab8972b976d6c69c5f5f.svg";